// extracted by mini-css-extract-plugin
export default {"btn":"Buttons_btn__sT7KS"};